module.exports = __webpack_public_path__ + "img/maintenance.c8cd7d5a.svg";